import { styled } from "@mui/material/styles";
import MenuList from "@mui/material/MenuList";
import ListItemText from "@mui/material/ListItemText";

export const Wrapper = styled(MenuList)(() => ({
  width: "250px",
  minWidth: "250px",
  display: "flex",
  flexDirection: 'column',
  justifyContent: 'stretch',
  overflowY: "scroll",
  height: 'calc(100vh - 150px)',
}));

export const StyledListItem = styled(ListItemText)(() => ({
  whiteSpace: "break-spaces",
}));
